<script setup>
import { useCollectionView } from '@/composables/data-view/collection';
import { provide, ref } from 'vue';
import Tabs from './Tabs.vue';
import Paginator from './paginator/Paginator.vue';
import Empty from './Empty.vue';
import FilterControls from './FilterControls.vue';

const props = defineProps({
    views: {
        type: Array,
        required: true,
    },
    filters: {
        type: Object,
        required: false,
    },
    defaultView: {
        type: String,
        required: false,
    },
    viewInQuery: {
        type: Boolean,
        default: true,
    },
    viewQueryString: {
        type: String,
        default: 'view',
    },
    queryString: {
        type: String,
        default: 'query',
    },
    paginationType: {
        type: String,
        default: 'infiniteScroll', // infiniteScroll, simple
        required: false,
    },
    fetchOnce: {
        type: Boolean,
        default: false,
    },
    queryViewMode: {
        type: String,
        default: 'inline', // inline, modal
    },
});

const el = ref();

const dataView = useCollectionView({ props, el });

defineExpose({
    dataView,
});

provide('dataView', dataView);
</script>

<template>
    <div ref="el" class="flex flex-col gap-4">
        <slot name="tabs">
            <Tabs />
        </slot>
        <slot name="filter-controls"  v-if="queryViewMode === 'inline'" :active-view="dataView.activeView">
            <FilterControls v-if="dataView.activeView.queryViewOpen" />
        </slot>
        <slot :active-view="dataView.activeView"></slot>
        <slot v-if="dataView.activeView.collection.fetched && dataView.activeView.data.length === 0" name="empty">
            <Empty />
        </slot>
        <slot v-if="paginationType" name="paginator">
            <Paginator />
        </slot>
    </div>
</template>
